import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PieChartText = ({ centerX, centerY, title, description, theme, }) => {
    const mainTextColor = theme === 'dark' ? '#fff' : 'rgba(0, 0, 0)';
    const secondTextColor = theme === 'dark' ? 'rgba(255, 255, 255, 0.59)' : 'rgba(0, 0, 0, 0.59)';
    return (_jsxs("g", { transform: `translate(${centerX}, ${centerY})`, children: [_jsx("text", { y: "-6px", textAnchor: "middle", dominantBaseline: "central", style: {
                    fontSize: '18px',
                    fontWeight: '600',
                    fill: mainTextColor,
                }, children: title }), _jsx("text", { y: "14", textAnchor: "middle", dominantBaseline: "central", style: {
                    fontSize: '12px',
                    fill: secondTextColor,
                }, children: description })] }));
};
